import { render, staticRenderFns } from "./CreateWorkingFile.vue?vue&type=template&id=70bf5c78&scoped=true&"
import script from "./CreateWorkingFile.vue?vue&type=script&lang=js&"
export * from "./CreateWorkingFile.vue?vue&type=script&lang=js&"
import style0 from "./CreateWorkingFile.vue?vue&type=style&index=0&id=70bf5c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bf5c78",
  null
  
)

export default component.exports